export default {
    chart: {
        type: 'packedbubble',
    },
    legend: {
        enabled: false
    },
    title: {
        text: ''
    },
    tooltip: {
        outside: true,
        format: '{point.focus_area_name}'
    },

    plotOptions: {
        packedbubble: {
            minSize: '50%',
            maxSize: '100%',
            zMin: 0,
            zMax: 15,
            layoutAlgorithm: {
                splitSeries: false,
                bubblePadding: 8,
                gravitationalConstant: 0.02
            },
            dataLabels: {
                enabled: true,
                format: '{point.label}<br>{point.value}&nbsp;partnerships',
                useHTML: true,
                style: {
                    color: 'black',
                    fontWeight: 'normal',
                    textAlign: 'center',
                    textOverflow: 'clip',
                    width: 80,
                    fontSize: '12px',
                    zIndex: 0
                }
            },

            point: {
                events: {}
            },
        },
    },
    series: []
}
